<template>
  <div class="col-lg-3 mb-2">
    <h1 class="display-1 mb-3 mb-md-4" v-html="title"></h1>
    <img :alt="title" :src="imgSrc" class="img-fluid mb-3" />
    <h2 class="display-2">
      <slot name="intro"></slot>
    </h2>
    <slot name="default"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'main-box',
  props: {
    title: String,
    imgSrc: String,
  },
});
</script>

<style lang="scss" scoped></style>
